import React from "react";
import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import * as viewReducer from "containers/View/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { getModelAccount } from "containers/ChatGPT/reducer";
import { Button } from "aible";
import { HiddenFilePicker } from "components/View/UploadModal";
import CSVIconPurple2 from "images/file-csv-light-purple.svg";
import { getOutcomeOptions, setDatasetTarget, getIsOutcomeMulticategorical, getDataset, getSuccessOptions, copyAndChangeDatasetTarget } from "containers/Home/reducer";
import { getSelectedAccountId } from "containers/Accounts/reducer";
import { isOptionType, selectOnChangeWrapper } from "utils/select";
import ConnectDataWarehouseButton from "components/Tiles/Sense/ConnectDataWarehouseButton";
import SchemaMonitorContainer from "components/SchemaMonitor/SchemaMonitor";
// skipAccountFilter bypasses the filtering for the account of the currently selected llm model
const DatasetSelector = ({ datasetId, onChange, forceDatasetSelection, selectorStyle, menuPlacement, className, isDisabled, isNewChat, isDynamic, isStyled, color, filter, skipAccountFilter, allowAllDatasets, skipSearchFilter, allowUpload, allowOutcomeSelect, hideJustChat, hideDataSearch, sampleDatasetId, sampleDatasetLabel, skipSqlAutoSwitch, skipSearchRawChatSwitch, outcomeSelectStyle, defaultAddData, isChatTemplate, checkRawFieldsFilter, allowDatabaseLink, includeSelectedDataset, style, ...retProps }) => {
    const dispatch = useDispatch();
    const datasets = useSelector((state) => viewReducer.getRawDatasets(state, undefined, skipSearchFilter));
    const dataset = useSelector((state) => getDataset(state, Number(datasetId)));
    const datasetInDatasets = datasets?.find((d) => d?.id === dataset?.id);
    const modelAccount = useSelector((state) => getModelAccount(state));
    const pickerRef = useRef(null);
    const selectedAccountId = useSelector((state) => getSelectedAccountId(state));
    const [isUploading, updateIsUploading] = useState(false);
    let retDatasets = [...datasets];
    if (includeSelectedDataset && dataset && !datasetInDatasets) {
        retDatasets = [dataset, ...retDatasets];
    }
    const datasetOptions = retDatasets
        .filter((d) => {
        if (includeSelectedDataset && d?.id === datasetId) {
            return true;
        }
        if (!skipAccountFilter && modelAccount && modelAccount !== d.account_id) {
            return false;
        }
        if (d?.dataset_status === "ERROR") {
            return false;
        }
        if (!allowAllDatasets && !(d?.outcome !== undefined && d?.number_of_rows > 0) && !allowUpload) {
            return false;
        }
        if (filter) {
            if (allowUpload && d?.id === datasetId) {
                return true;
            }
            if (typeof filter === "function") {
                const hasFilteredField = filter(d);
                if (!hasFilteredField) {
                    return false;
                }
            }
            else if (filter !== undefined) {
                const hasFilteredField = d?.ranked_fields?.find((f) => f.type === filter);
                const hasFilteredRawField = Object.keys(d?.fields)?.find((fKey) => d?.fields[fKey].type === filter);
                if (!hasFilteredField) {
                    if (checkRawFieldsFilter) {
                        if (!hasFilteredRawField) {
                            return false;
                        }
                        return true;
                    }
                    return false;
                }
            }
        }
        return true;
    })
        .map((d) => {
        return {
            value: d.id,
            label: `(${d.id}) ${d.name}`
        };
    });
    /*
    if (!forceDatasetSelection) {
      datasetOptions.unshift({
        value: "ALL_AVAILABLE_DATA",
        label: "All available data"
      })
    }
    */
    const UPLOAD_OPTION = {
        label: "Add More Data",
        value: "UPLOAD_CSV"
    };
    if (allowUpload) {
        datasetOptions.unshift(UPLOAD_OPTION);
    }
    if (!hideJustChat) {
        datasetOptions.unshift({
            value: "CHATAIBLE_RAW_CHAT",
            label: "Just Chat"
        });
    }
    if (!hideDataSearch) {
        datasetOptions.unshift({
            value: "CHATAIBLE_DATA_SEARCH",
            label: "Search all available data"
        });
    }
    if (sampleDatasetId && sampleDatasetLabel) {
        datasetOptions.unshift({
            value: sampleDatasetId,
            label: sampleDatasetLabel
        });
    }
    const retValue = datasetOptions.find((v) => v?.value === datasetId);
    const outcomeOptions = useSelector((state) => getOutcomeOptions(state, Number(datasetId)));
    const [localOutcome, updateLocalOutcome] = useState(dataset?.outcome);
    const successOptions = useSelector((state) => getSuccessOptions(state, Number(datasetId), dataset, localOutcome));
    const [localTargetVal, updateLocalTargetVal] = useState(dataset?.target_value?.[0]);
    const resetLocalOutcomeState = () => {
        updateLocalOutcome(dataset?.outcome);
        updateLocalTargetVal(dataset?.target_value?.[0]);
    };
    useEffect(() => {
        resetLocalOutcomeState();
    }, [datasetId]);
    let isSelOutcomeMulticategorical = false;
    let selOutcomeSuccessOptions = [];
    const selectedOutcomeIsMulticategorical = useSelector((state) => getIsOutcomeMulticategorical(state, Number(datasetId), undefined, localOutcome));
    if (localOutcome !== undefined && selectedOutcomeIsMulticategorical) {
        isSelOutcomeMulticategorical = true;
        selOutcomeSuccessOptions = successOptions;
    }
    const isProcessing = dataset?.status_name && dataset?.status_name !== "DONE";
    useEffect(() => {
        if (!isProcessing) {
            resetLocalOutcomeState();
        }
    }, [isProcessing]);
    const foundTargetOutcome = outcomeOptions?.find((option) => {
        const targetOutcome = localOutcome;
        if (targetOutcome !== undefined) {
            return option?.value === targetOutcome;
        }
        return false;
    }) ?? null;
    const foundOutcomeTargetValue = selOutcomeSuccessOptions.find((o) => o.value === localTargetVal) ?? null;
    const isCSVUpload = useSelector((state) => chatGPTReducer.getIsCSVUpload(state));
    const selectedBlueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const handleChange = (val) => {
        console.log("handle change val?", val);
        const isCSVUploadUpdate = allowUpload && val === "UPLOAD_CSV";
        console.log("isCsvUpload, update, allowUpload, val: ", isCSVUpload, isCSVUploadUpdate, allowUpload, val);
        if (isCSVUploadUpdate !== isCSVUpload) {
            dispatch(chatGPTReducer.updateIsCSVUpload(isCSVUploadUpdate));
        }
        if (val === "CHATAIBLE_DATA_SEARCH" || val === "CHATAIBLE_RAW_CHAT") {
            onChange(undefined);
            if (!skipSearchRawChatSwitch) {
                return dispatch(chatGPTReducer.updateBlueprintId(val));
            }
            else {
                return;
            }
        }
        else if ((selectedBlueprintId === "CHATAIBLE_DATA_SEARCH" || selectedBlueprintId === "CHATAIBLE_RAW_CHAT") &&
            !skipSqlAutoSwitch) {
            dispatch(chatGPTReducer.updateBlueprintId("CHATAIBLE_SQL"));
        }
        if (val === "ALL_AVAILABLE_DATA" || val === "UPLOAD_CSV") {
            if (datasetId !== undefined) {
                onChange(undefined);
            }
        }
        else {
            onChange(val);
        }
    };
    // useEffect(() => {
    //   const retValue =
    //     datasetOptions.find(v => v.value === datasetId) !== undefined ?
    //     datasetOptions.find(v => v.value === datasetId) :
    //     datasetOptions.find(v => v.value === selectedBlueprintId);
    //   handleChange(retValue?.value)
    // }, [datasetId]);
    // useEffect(() => {
    //     if (retValue?.value === undefined && (allowUpload && defaultAddData)) {
    //         handleChange("UPLOAD_CSV");
    //     }
    // }, []);
    const hasModifiedOutcome = !localOutcome ||
        localOutcome !== dataset?.outcome ||
        (isSelOutcomeMulticategorical && (localTargetVal === undefined || localTargetVal !== dataset?.target_value?.[0]));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.datasetSelector + " " + (className ? className : ""), style: style, ...retProps },
            React.createElement(DynamicWidthSelector, { options: datasetOptions, value: retValue, onChange: selectOnChangeWrapper(handleChange), placeholder: "Select Dataset", menuPlacement: menuPlacement ?? "top", isDisabled: isDisabled || (isChatTemplate && isProcessing), isSearchable: true, isDynamic: isDynamic, isNewChat: isNewChat, isStyled: isStyled, style: selectorStyle, color: color })),
        React.createElement("div", { style: { display: "flex" } }, allowUpload && isCSVUpload && (React.createElement("div", { style: allowDatabaseLink ? { display: "flex" } : { display: "flex", justifyContent: "center", width: "100%" } },
            React.createElement(HiddenFilePicker, { innerRef: pickerRef, onStart: () => updateIsUploading(true), onComplete: () => {
                    dispatch(chatGPTReducer.updateIsCSVUpload(false));
                    updateIsUploading(false);
                }, selectDatasetOnComplete: allowUpload }),
            React.createElement(Button, { type: isChatTemplate ? "primary" : "secondary", style: { marginRight: "12px" }, disabled: !selectedAccountId || isUploading, onClick: () => pickerRef?.current?.click(), isLoading: isUploading, loadingText: "Uploading..." },
                "Upload CSV",
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("img", { src: CSVIconPurple2 })))),
            allowDatabaseLink && (React.createElement(React.Fragment, null,
                React.createElement(SchemaMonitorContainer, { selectDataOnLink: true }),
                React.createElement(ConnectDataWarehouseButton, null)))))),
        allowUpload &&
            dataset?.status_name &&
            dataset?.status_name === "DONE" &&
            (!dataset?.outcome || isChatTemplate) &&
            allowOutcomeSelect && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: isNewChat ? styles.headerText : undefined }, "What KPI would you like to evaluate?"),
            React.createElement("div", { style: outcomeSelectStyle ? outcomeSelectStyle : isNewChat ? { marginLeft: "-9px" } : undefined },
                React.createElement(DynamicWidthSelector, { placeholder: "Select an outcome", options: outcomeOptions, value: foundTargetOutcome, onChange: selectOnChangeWrapper((val) => {
                        updateLocalOutcome(val);
                        updateLocalTargetVal(undefined);
                    }), menuPlacement: menuPlacement ?? "top", isDisabled: isDisabled, isSearchable: true, isDynamic: isDynamic, isNewChat: isNewChat, isStyled: isStyled, style: selectorStyle, color: color })),
            isSelOutcomeMulticategorical && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: isNewChat ? styles.headerText : undefined }, "is  "),
                React.createElement("div", { style: isNewChat
                        ? { marginLeft: "-9px", marginRight: "16px" }
                        : isChatTemplate
                            ? { width: "100%", marginBottom: "8px" }
                            : undefined },
                    React.createElement(DynamicWidthSelector, { options: selOutcomeSuccessOptions, onChange: (val) => {
                            if (!isOptionType(val)) {
                                return;
                            }
                            updateLocalTargetVal(val?.value);
                        }, value: foundOutcomeTargetValue, placeholder: "Select a Category", menuPlacement: menuPlacement ?? "top", isDisabled: isDisabled, isSearchable: true, isDynamic: isDynamic, isNewChat: isNewChat, isStyled: isStyled, style: selectorStyle, color: color })))))),
        allowUpload &&
            datasetId !== undefined &&
            (!dataset?.outcome || isProcessing || (isChatTemplate && hasModifiedOutcome)) &&
            allowOutcomeSelect ? (React.createElement("div", { className: "flex justify-center" },
            React.createElement(Button, { onClick: async () => {
                    if (typeof datasetId === "number" && localOutcome) {
                        // If there's no outcome, set the outcome.
                        if (!dataset?.outcome) {
                            dispatch(setDatasetTarget(datasetId, localOutcome, isSelOutcomeMulticategorical ? localTargetVal : undefined));
                            // Otherwise we create a copy of the dataset and select it afterward.
                        }
                        else {
                            let newDataset;
                            try {
                                newDataset = await dispatch(copyAndChangeDatasetTarget(datasetId, localOutcome, isSelOutcomeMulticategorical ? localTargetVal : undefined));
                                resetLocalOutcomeState();
                                if (newDataset && newDataset?.id) {
                                    onChange(newDataset?.id);
                                }
                            }
                            catch {
                                console.log("New dataset could not be created.");
                            }
                        }
                    }
                }, disabled: localOutcome === undefined || (isSelOutcomeMulticategorical && localTargetVal === undefined), isLoading: isProcessing, loadingText: React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start" } },
                    React.createElement("div", { style: { fontSize: "13px", color: "#8d8d8d" } }, dataset?.target_value
                        ? `Evaluating ${dataset?.target} is ${dataset?.target_value}`
                        : dataset?.target
                            ? `Evaluating ${dataset?.target}`
                            : `Evaluating`),
                    React.createElement("div", { style: { fontSize: "13px", fontWeight: 400 } }, "THIS MAY TAKE LONGER FOR LARGER DATASETS")), type: "primary", style: { width: "fit-content" } }, "Evaluate KPI"),
            dataset?.outcome !== undefined && !isProcessing && hasModifiedOutcome && (React.createElement(Button, { onClick: () => {
                    resetLocalOutcomeState();
                }, className: "ml-[10px]" }, "Reset")))) : isProcessing ? (React.createElement(Button, { onClick: () => null, disabled: true, isLoading: isProcessing, loadingText: React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "flex-start" } },
                React.createElement("div", { style: { fontSize: "13px", color: "#8d8d8d" } }, "PROCESSING."),
                React.createElement("div", { style: { fontSize: "13px", fontWeight: 400 } }, "THIS MAY TAKE LONGER FOR LARGER DATASETS")), type: "primary", style: { width: "fit-content" } }, "Evaluate KPI")) : (React.createElement(React.Fragment, null))));
};
export default DatasetSelector;
